document.addEventListener('DOMContentLoaded', function () {
  // Scroll fade-in. IntersectionObserver callback může u sekcí viditelných
  // hned při načtení (above the fold) v ojedinělých případech nespustit kvůli
  // časování layoutu, což by nechalo obsah trvale na opacity:0 — proto
  // sekce už v okamžiku pozorování zkontrolujeme ručně a přidáme pojistku,
  // která po 1,5 s odkryje cokoliv, co observer přesto nezachytil.
  var sections = document.querySelectorAll('.flowik-section');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('is-visible');
    });
  }, { threshold: 0.1 });
  sections.forEach(function (s) {
    var rect = s.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) s.classList.add('is-visible');
    observer.observe(s);
  });
  setTimeout(function () {
    sections.forEach(function (s) { s.classList.add('is-visible'); });
  }, 1500);

  // Sticky header shrink
  var header = document.querySelector('.flowik-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 80);
    });
  }

  // Mobile hamburger menu
  var hamburger = document.querySelector('[data-flowik-hamburger]');
  var navOverlay = document.querySelector('[data-flowik-nav-overlay]');
  if (hamburger && navOverlay) {
    hamburger.addEventListener('click', function () { navOverlay.classList.add('is-open'); });
    navOverlay.querySelectorAll('[data-flowik-nav-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { navOverlay.classList.remove('is-open'); });
    });
    navOverlay.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { navOverlay.classList.remove('is-open'); });
    });
  }

  // Back to top
  var totop = document.querySelector('[data-flowik-totop]');
  if (totop) {
    window.addEventListener('scroll', function () {
      totop.classList.toggle('is-visible', window.scrollY > 400);
    });
    totop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // Scroll progress bar
  var progress = document.querySelector('[data-flowik-progress]');
  if (progress) {
    window.addEventListener('scroll', function () {
      var pct = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
      progress.style.width = pct + '%';
    });
  }

  // Cookie consent
  var cookieBanner = document.querySelector('[data-flowik-cookie]');
  if (cookieBanner) {
    if (localStorage.getItem('flowik_cookie_consent')) {
      cookieBanner.classList.add('is-hidden');
    } else {
      cookieBanner.querySelector('button').addEventListener('click', function () {
        localStorage.setItem('flowik_cookie_consent', '1');
        cookieBanner.classList.add('is-hidden');
      });
    }
  }

  // Nav dropdown: Kolekce, hover on desktop (debounced), click on touch
  var navDropdown = document.querySelector('.flowik-nav-dropdown');
  if (navDropdown) {
    var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    var trigger = navDropdown.querySelector('.flowik-nav-dropdown-trigger');
    var closeTimer = null;

    function openDropdown() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      navDropdown.classList.add('is-open');
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { navDropdown.classList.remove('is-open'); }, 150);
    }

    if (!isTouch) {
      navDropdown.addEventListener('mouseenter', openDropdown);
      navDropdown.addEventListener('mouseleave', scheduleClose);
    } else if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        navDropdown.classList.toggle('is-open');
      });
      document.addEventListener('click', function (e) {
        if (!navDropdown.contains(e.target)) navDropdown.classList.remove('is-open');
      });
    }
  }

  // Calculator nav trigger: redirect to the single calculator on homepage
  var calcTrigger = document.querySelector('[data-flowik-calc-trigger]');
  if (calcTrigger) {
    calcTrigger.addEventListener('click', function () {
      window.location.href = '/#kalkulacka';
    });
  }

  // Sample form UX: char counter + checkmark on success
  var noteField = document.querySelector('[data-flowik-note]');
  var noteCount = document.querySelector('[data-flowik-note-count]');
  if (noteField && noteCount) {
    var maxLen = 230;
    noteField.addEventListener('input', function () {
      var remaining = maxLen - noteField.value.length;
      noteCount.textContent = remaining + ' znaků zbývá';
    });
  }

  // Sample form: tier selection (1 / 3 / 5 vzorků) drives max swatch selection and price
  var tierButtons = document.querySelector('[data-flowik-sample-tiers]');
  var swatchSelect = document.querySelector('[data-flowik-swatch-select]');
  var swatchInput = document.querySelector('[data-flowik-swatch-input]');
  var swatchLabel = document.querySelector('[data-flowik-swatch-label]');
  var swatchInstructions = document.querySelector('[data-flowik-swatch-instructions]');
  var tierCountInput = document.querySelector('[data-flowik-tier-count-input]');
  var tierPriceInput = document.querySelector('[data-flowik-tier-price-input]');
  var tierPriceDisplay = document.querySelector('[data-flowik-tier-price-display]');

  function updateSwatchLabel() {
    if (!swatchSelect || !swatchLabel) return;
    var active = Array.prototype.slice.call(swatchSelect.querySelectorAll('.flowik-swatch.is-active'))
      .map(function (b) { return b.dataset.decor; });
    swatchLabel.textContent = active.length ? active.join(', ') : 'Zatím nevybráno';
    if (swatchInput) swatchInput.value = active.join(', ');
  }

  function setMaxSelect(max) {
    if (!swatchSelect) return;
    swatchSelect.dataset.maxSelect = max;
    var active = swatchSelect.querySelectorAll('.flowik-swatch.is-active');
    if (active.length > max) {
      Array.prototype.slice.call(active).slice(max).forEach(function (b) { b.classList.remove('is-active'); });
    }
    if (active.length === 0 && swatchSelect.querySelector('.flowik-swatch')) {
      swatchSelect.querySelector('.flowik-swatch').classList.add('is-active');
    }
    if (swatchInstructions) {
      swatchInstructions.textContent = max === 1 ? 'Vyberte 1 dekor' : 'Vyberte až ' + max + ' dekorů';
    }
    updateSwatchLabel();
  }

  if (swatchSelect) {
    swatchSelect.querySelectorAll('.flowik-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var max = parseInt(swatchSelect.dataset.maxSelect, 10) || 1;
        var isActive = btn.classList.contains('is-active');
        var activeCount = swatchSelect.querySelectorAll('.flowik-swatch.is-active').length;
        if (isActive) {
          if (activeCount > 1) btn.classList.remove('is-active');
        } else if (activeCount < max) {
          btn.classList.add('is-active');
        } else if (max === 1) {
          swatchSelect.querySelectorAll('.flowik-swatch').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        }
        updateSwatchLabel();
      });
    });
  }

  if (tierButtons) {
    tierButtons.querySelectorAll('.flowik-sample-tier').forEach(function (btn) {
      btn.addEventListener('click', function () {
        tierButtons.querySelectorAll('.flowik-sample-tier').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var count = parseInt(btn.dataset.tierCount, 10);
        var price = btn.dataset.tierPrice;
        if (tierCountInput) tierCountInput.value = count;
        if (tierPriceInput) tierPriceInput.value = price + ' Kč';
        if (tierPriceDisplay) tierPriceDisplay.textContent = price + ' Kč';
        setMaxSelect(count);
      });
    });
  }

  // Honeypot anti-spam: block submit if hidden field is filled
  document.querySelectorAll('form').forEach(function (form) {
    var honeypot = form.querySelector('[name="website"]');
    if (honeypot) {
      form.addEventListener('submit', function (e) {
        if (honeypot.value) e.preventDefault();
      });
    }
  });

  // Animated counters
  function animateCounter(el, target, duration) {
    duration = duration || 1500;
    var start = null;
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      el.textContent = Math.floor(progress * target);
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target;
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-flowik-counter]');
  if (counters.length) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.dataset.counted) {
          entry.target.dataset.counted = '1';
          animateCounter(entry.target, parseInt(entry.target.dataset.flowikCounter, 10));
        }
      });
    }, { threshold: 0.3 });
    counters.forEach(function (c) { counterObserver.observe(c); });
  }

  // Exit intent popup: min. 30s on page (desktop) before mouse-toward-top triggers it,
  // or 45s of scroll inactivity on mobile. Once per session.
  var exitOverlay = document.querySelector('[data-flowik-exit-overlay]');
  if (exitOverlay) {
    var exitShown = false;
    var pageEnteredAt = Date.now();
    var MIN_DWELL_MS = 30000;

    function showExitPopup() {
      if (exitShown || sessionStorage.getItem('flowik_exit_shown')) return;
      exitOverlay.classList.add('is-open');
      exitShown = true;
      sessionStorage.setItem('flowik_exit_shown', '1');
    }

    if (window.innerWidth >= 900) {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY < 50 && (Date.now() - pageEnteredAt) >= MIN_DWELL_MS) {
          showExitPopup();
        }
      });
    } else {
      var inactivityTimer = setTimeout(showExitPopup, 45000);
      window.addEventListener('scroll', function () {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(showExitPopup, 45000);
      });
    }

    exitOverlay.querySelectorAll('[data-flowik-exit-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { exitOverlay.classList.remove('is-open'); });
    });
    exitOverlay.addEventListener('click', function (e) {
      if (e.target === exitOverlay) exitOverlay.classList.remove('is-open');
    });
  }
});

/* AI poradce: předvyplní formulář vzorků dekory doporučenými z fotky */
(function () {
  'use strict';
  function prefillFromAi() {
    var titles;
    try { titles = JSON.parse(sessionStorage.getItem('flowik_ai_decors') || 'null'); } catch (e) { return; }
    if (!Array.isArray(titles) || titles.length === 0) return;

    var swatchSelect = document.querySelector('[data-flowik-swatch-select]');
    if (!swatchSelect) return;

    /* Přepni tarif na 3 vzorky, pokud existuje */
    var tierBtn = document.querySelector('[data-flowik-sample-tiers] .flowik-sample-tier[data-tier-count="3"]');
    if (tierBtn) tierBtn.click();

    var matched = 0;
    swatchSelect.querySelectorAll('.flowik-swatch').forEach(function (btn) {
      btn.classList.remove('is-active');
    });
    swatchSelect.querySelectorAll('.flowik-swatch').forEach(function (btn) {
      if (matched < 3 && titles.indexOf(btn.dataset.decor) !== -1) {
        btn.classList.add('is-active');
        matched++;
      }
    });
    if (matched === 0) return;

    /* Aktualizace labelu a hidden inputu stejně jako při ručním výběru */
    var active = Array.prototype.slice.call(swatchSelect.querySelectorAll('.flowik-swatch.is-active'))
      .map(function (b) { return b.dataset.decor; });
    var label = document.querySelector('[data-flowik-swatch-label]');
    var input = document.querySelector('[data-flowik-swatch-input]');
    if (label) label.textContent = active.join(', ');
    if (input) input.value = active.join(', ');

    try { sessionStorage.removeItem('flowik_ai_decors'); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillFromAi);
  } else {
    prefillFromAi();
  }
})();

/* PDP gallery: click thumbnail to swap main image (funguje na klik i tap) */
(function () {
  'use strict';
  document.querySelectorAll('[data-flowik-pdp-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-flowik-pdp-main-img]');
    var thumbs = gallery.querySelectorAll('[data-flowik-pdp-thumb]');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.fullSrc;
        if (!src) return;
        mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
})();
